import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface PersonalProps {
    onDataChange: (data: any) => void
    userDet?: any;
    onNext: () => void
}

const Personal: React.FC<PersonalProps> = ({ onDataChange, userDet, onNext }) => {

    let initialFormState;
    if (userDet != null) {
        initialFormState = {
            userId: userDet.internalUserId, firstname: userDet.internalUserFirstName, lastname: userDet.internalUserLastName, dob: userDet.internalUserBirthDate, phonenum: userDet.internalUserPhone,
            address: userDet.internalUserAddress, state: userDet.internalUserState, city: userDet.internalUserCity, pincode: userDet.internalUserPincode, email: userDet.internalUserEmail
        }
    }
    else {
        initialFormState = {
            firstname: '', lastname: '', dob: '', phonenum: '', address: '', state: '', city: '', pincode: '', email: ''
        }
    }
    const [formData, setFormData] = useState(initialFormState);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
        onDataChange(updatedData); // Send data to AddStudent
    };

    useEffect(() => {
        if (userDet != null) {
            setFormData(initialFormState);
            onDataChange(initialFormState);
        }
    }, [])

    return (
        <form>
            <div className="card card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label className="form-label">First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="firstname"
                                        value={formData.firstname}
                                        onChange={handleChange}
                                        placeholder="First Name" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="lastname"
                                        value={formData.lastname}
                                        onChange={handleChange}
                                        placeholder="Last Name" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Date of Birth</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        placeholder="Date of Birth" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Phone Number</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="phonenum"
                                        value={formData.phonenum}
                                        onChange={handleChange}
                                        placeholder="Phone"
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <label className="form-label">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder="Address" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        placeholder="City" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        placeholder="State" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Pincode</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="pincode"
                                        value={formData.pincode}
                                        onChange={handleChange}
                                        placeholder="Pincode" />
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Email" />
                                </div>

                                <div className="text-end btn-row" style={{ boxShadow: "none", marginTop: "0px" }}>
                                    {/* <Link className="btn btn-primary me-3 btn-icon" to="#"><i className="feather-arrow-left-circle me-1" /> Back</Link> */}
                                    <Link className="btn btn-secondary btn-icon" to="#" onClick={onNext}>Next <i className="feather-arrow-right-circle ms-1" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Personal;